/**
 * Formats a number with adaptive abbreviation: M for millions, K for thousands.
 * Used for chart center text and compact displays.
 * @param {number} value The numeric value
 * @param {string} [currencySymbol='$'] The currency symbol
 * @returns {string}
 */
export function formatCompactCurrency(value, currencySymbol = '$') {
  if (value === undefined || value === null || isNaN(value)) return '-';
  if (value >= 1_000_000) return `${currencySymbol}${(value / 1_000_000).toFixed(2)}M`;
  if (value >= 1_000) return `${currencySymbol}${(value / 1_000).toFixed(2)}K`;
  return `${currencySymbol}${value.toFixed(0)}`;
}
